import React from "react";
import classnames from "classnames";
import useStyles from "./FmIcon.style";

interface FmIconProps {
  url: string;
  title?: string;
  className?: string;
  pointer?: boolean;
  onClick?: any;
}

const FmIcon = ({ url, title, className, pointer, onClick }: FmIconProps) => {
  const classes = useStyles();
  return <img className={classnames(classes.imageIcon, className)} src={url} alt={title} title={title} onClick={onClick} />;
};

export default FmIcon;
